import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-lock-outline",
  "use": "icon-lock-outline-usage",
  "viewBox": "0 0 9 9",
  "content": "<symbol viewBox=\"0 0 9 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-lock-outline\">\n    <rect x=\"2\" y=\"3\" width=\"5\" height=\"4\" rx=\"1\" fill=\"#42526E\" />\n    <path d=\"M5.5 2.5V5.5C5.5 6.05228 5.05228 6.5 4.5 6.5C3.94772 6.5 3.5 6.05228 3.5 5.5V2.5C3.5 1.94772 3.94772 1.5 4.5 1.5C5.05228 1.5 5.5 1.94772 5.5 2.5Z\" stroke=\"#42526E\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol